export default {

    checkOtherVariantLink(account) {
        switch(account) {
            case 'mobile.twitter.com':
                return 'twitter';
            case 'm.facebook.com':
                return 'facebook';
            case 'www.fb.me':
                return 'facebook';
            case 'fb.watch':
                return 'facebook';
            case 'm.youtube.com':
                return 'youtube';
            case 'vm.tiktok.com':
                return 'tiktok';
            case 'linkedin.com':
                return 'linkedin';
            default:
                return false;
        }
    },
    getLinkByName(name) {
        if (!name) return ""
        switch(name.toLowerCase()) {
            case 'facebook':
                return "https://facebook.com/";
            case 'instagram':
                return "https://instagram.com/";
            case 'twitter':
                return "https://twitter.com/";
            case 'youtube':
                return "https://youtube.com/";
            case 'tiktok':
                return "https://tiktok.com/";
            case 'linkedin':
                return "https://www.linkedin.com/"
            default:
                return ""
        }
    },
    parseLink(link, account) {
        if (link.length) {
            let arr = link.split('/')
            let checking = false;
            let fullAccount = account + '.com';
            if (arr.length > 1) {
                checking = (arr[0] === 'https:');
                if (checking === true && arr.length >= 3) {
                    checking = (arr[2] === fullAccount) || (arr[2] === 'www.' + fullAccount);

                    if (!checking) {
                        let checkAccount = this.checkOtherVariantLink(arr[2]);
                        checking = (checkAccount === account);
                    }
                    if (checking === true && arr.length >= 4) {
                        checking = Boolean(arr[3].trim().length);
                    } else {
                        checking = false;
                    }
                } else {
                    checking = false;
                }
            }
            return checking;
        }
    },

    checkCyrillicStr(str) {
        let cyrillicPattern = /[а-я]/i;
        return !(cyrillicPattern.test(str));
    },

    checkSpaces(str) {
        return str.indexOf(' ') === -1
    },

    checkLink(link, account) {
        if (!this.checkSpaces(link)) {
            return {isValid: false, message: 'There must be no spaces in this field'};
        }
        if (link) {
            if (!this.checkCyrillicStr(link)) {
                return {isValid: false, message: 'Url address must not contain Cyrillic characters'}
            }

            if (!this.parseLink(link, account)) {
                return {isValid: false, message: 'Invalid url address'};
            }

            return {isValid: true};
        }
        return {isValid: true};
    },

    replaceHTML(text) {
        let str = text;
        if (text.match(/<[^<>]+>/g)) {
            str = text.trim().replace(/<[^<>]+>/g, ' ')
        }
        return str;
    },

    formatTextForOutput(text) {
        let str = this.replaceHTML(text);
        return str.replace(/\n/g, '<br />');
    },
    choosePricingImageSrc(name, position) {
        name = name.toLowerCase()
        const names = ['free', 'monthly', 'yearly']
        const isIncluded = names.includes(name)
        if (isIncluded) return `/img/${name}-${position}.svg`
        else if (position === 'top') return ''
        else return  `/img/${names[0]}-${position}.svg`
    },
}